import React from 'react';
import { Row, Col, Button, Spin } from 'antd';
import './assets/css/package.css';
import dummyImage from './assets/Rectangle 187.png';
import calendarIcon from './assets/calendar 1.png';
import { useHistory, useParams } from 'react-router';
import {
  useGetAllPackagesQuery,
  useGetPackagesDetailsByIdQuery,
} from './packageSlice';
import {
  CatchReportSlider,
  PackagesSlider,
} from '../../common/components/sliders';

import breakfastIcon from './assets/croissant.svg';
import wifiIcon from './assets/wi-fi.svg';
import taxiIcon from './assets/location.svg';
import mealIcon from './assets/lunch.svg';
import otherBenefitIcon from './assets/star.svg';
import { useGetFisheryQuery } from '../../fishery_profile/fisherySlice';

function PackageDetails() {
  const fisheryId = useParams()['fishery_id'];
  const packageId = useParams()['package_id'];
  const history = useHistory();
  const { data: packages, isLoading: packageDetailLoading } =
    useGetPackagesDetailsByIdQuery(
      { fishery_id: fisheryId, package_id: packageId },
      {
        skip: !fisheryId && !packageId,
      }
    );
  const { data: AllPackages, isLoading: packagesLoading } =
    useGetAllPackagesQuery(fisheryId, {
      skip: !fisheryId,
    });
  const { data: fisheryData } = useGetFisheryQuery(fisheryId);
  let Package = packages?.[0];
  return (
    <div className='booking-container'>
      <div style={{ maxWidth: 1400 }} className='mg-auto'>
        <div
          className='package-details-container details'
          style={{ marginTop: 140 }}
        >
          {packageDetailLoading ? (
            <div className='row-center'>
              <Spin />
            </div>
          ) : (
            <Row gutter={[40, 20]} className='package-row '>
              <Col
                xs={{ order: 2, span: 24 }}
                md={{ span: 14, order: 1 }}
                className='package-content'
              >
                <h3 className='package-title'>{Package?.name}</h3>
                <p className='package-description'>{Package?.description}</p>

                {/* Features */}
                <Row gutter={[10, 10]} className='details-package-features'>
                  {Package?.included_benefits
                    .filter((b) => b.selected)
                    .map((benefit) => (
                      <Col xs={12} sm={8}>
                        <div className='feature-item'>
                          <img
                            src={
                              benefit?.label === 'Daily Breakfast'
                                ? breakfastIcon
                                : benefit?.label === 'Internet'
                                  ? wifiIcon
                                  : benefit?.label === 'Pickup Included' ||
                                      benefit?.label === 'Dropoff Included'
                                    ? taxiIcon
                                    : benefit?.label === 'Meals Included'
                                      ? mealIcon
                                      : ''
                            }
                            width={18}
                            height={18}
                            alt='benefit'
                            className='mg-right-5'
                          />{' '}
                          {benefit?.customText
                            ? benefit?.customText
                            : benefit?.label}
                        </div>
                      </Col>
                    ))}
                  {Package?.other_benefits?.data
                    .filter((b) => b.selected)
                    .map((benefit) => (
                      <Col xs={12} sm={8}>
                        <span className='feature-item'>
                          <img
                            src={otherBenefitIcon}
                            width={16}
                            height={16}
                            alt='benefit'
                            className='mg-right-5'
                          />{' '}
                          {benefit?.name}
                        </span>
                      </Col>
                    ))}
                </Row>

                {/* Pricing */}
                <div className='package-pricing'>
                  <div className='package-details-price-container mg-bottom-10  row-center justify-between'>
                    <span className='package-price-label   font-montserrat sb-blue-700'>
                      PACKAGE PRICE
                    </span>
                    <div className='package-price  sb-blue-bg-100 font-montserrat sb-blue-700'>
                      {fisheryData?.currency}
                      {(Package?.final_price_in_pence / 100).toFixed(2)}
                    </div>
                  </div>
                  <div className='package-details-price-container  row-center justify-between'>
                    <span className='package-price-label   font-montserrat sb-blue-700'>
                      PAY TODAY
                    </span>
                    <div className='package-price  sb-blue-bg-100 font-montserrat sb-blue-700'>
                      {fisheryData?.currency}
                      {((Package?.final_price_in_pence / 100) * 0.3).toFixed(2)}
                    </div>
                  </div>
                </div>

                {/* Booking Button */}
                <Button
                  className='details-book-button'
                  onClick={() => {
                    history.push(
                      `/booking/package/reservation/${fisheryId}/${Package?.id}`
                    );
                  }}
                >
                  CHECK AVAILABILITY & BOOK NOW
                </Button>
              </Col>
              <Col
                xs={{ order: 1, span: 24 }}
                md={{ span: 10, order: 2 }}
                className='package-image-container'
              >
                <div className='package-image-wrapper'>
                  <img
                    src={Package?.package_image}
                    alt='Fishing Package'
                    className='package-details-image'
                  />
                </div>
              </Col>
            </Row>
          )}
        </div>
        {AllPackages && (
          <PackagesSlider
            lakesData={AllPackages}
            fisheryPublicId={fisheryId}
            loading={packagesLoading}
          />
        )}
      </div>
    </div>
  );
}

export default PackageDetails;
